import React from 'react';
import style from './auth.module.scss';
import {useTranslation} from 'react-i18next';
const ResetButton = ({submit,...props}) => {
    const {t} = useTranslation();
    return (
        <div className={style.loginButton} style={{marginTop:10}}>
            <button className={`${style.loginFormBtn}`} onClick={submit} disabled={props.disabled}>{t('Login.ResetBtn')}</button>
        </div>
    );
};

export default ResetButton;